import { usePetitionDetailsPageData } from '#src/app/pages/petitionDetails/pageContext';

export type TrackingPetitionStatus = 'victory' | 'closed' | 'active';

export function useTrackingPetitionStatus(): TrackingPetitionStatus {
	const {
		data: {
			petition: { status },
		},
	} = usePetitionDetailsPageData();

	switch (status) {
		case 'VICTORY':
			return 'victory';
		case 'CLOSED':
			return 'closed';
		default:
			return 'active';
	}
}
